const brand = `<!--begin::Brand-->
<div class="aside-logo py-8" id="kt_aside_logo">
    <!--begin::Logo-->
    <a data-navigo href="/" class="d-flex align-items-center">
        <img alt="Logo" src="assets/media/logos/pdx-logo-3d.png" class="h-45px logo" />
    </a>
    <!--end::Logo-->
</div>
<!--end::Brand-->`;

const view = /* html */ `
    ${brand}
    

    <!--<div class="btn btn-icon position-relative w-10px h-10px pulse pulse-success mt-2 text-center" style="width:100% !important;" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="right" data-i18n="[title]aside.online;[data-bs-original-title]aside.online">
       
        <div style="height: 6px;
            width: 6px;
            border-radius: 100%;
            background-color: #b5fe1b;
            display:inline-block"></div>
        <span class="pulse-ring w-20px h-20px"></span>
	</div>
    <div id="aside-total-online" class="text-gray-700 fs-8 fw-bold text-center" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="right" data-i18n="[title]aside.online;[data-bs-original-title]aside.online">0</div>-->
    <!--begin::Aside menu-->
    <style>
        .side-sub.active i {
            color: #FF8800 !important;
        }
        .menu-item .btn.btn-active-light.active, .menu-item .btn.btn-active-light:hover {
            background-color: #1b1b1b !important;
            border-color: #1b1b1b !important;
        }

        .menu-item .btn.btn-active-light:hover i {
            color: #FF8800 !important;
        }

        
    </style>
    
    <div class="aside-menu flex-column-fluid" id="kt_aside_menu">

        <!--begin::Aside Menu-->
        <div class="hover-scroll-overlay-y my-2 my-lg-5 pe-lg-n1" id="kt_aside_menu_wrapper" data-kt-scroll="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer" data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="5px">
            <!--begin::Menu-->
            <!--<div class="menu menu-column menu-title text-uppercase fs-8-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold" id="#kt_aside_menu" data-kt-menu="true">-->
            <div class="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-semibold" data-kt-menu="true">

                <!--<div class="menu-item py-1 side-item" id="where-news">
                    <a href="news" data-navigo class="menu-link menu-center position-relative" title="All news & announcements" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tnews;[data-bs-original-title]aside.tnews">
                        <span class="menu-icon me-0">                            
                            <i class="fad fa-newspaper"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.news">News</span>
                        <span class="position-absolute top-0 start-50 translate-middle badge badge-light-primary fs-9" style="text-transform: none;" data-i18n="example.new">New</span>                        
                    </a>
                </div>-->
                
                <!--<div class="menu-item py-1 side-item" id="where-play">
                    <a href="play" data-navigo class="menu-link menu-center" title="Let's Play" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tplay;[data-bs-original-title]aside.tplay">
                        <span class="menu-icon me-0">                            
                            <i class="fad fa-play"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.play">Play</span>
                    </a>
                </div>-->

                <!--<div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item py-1 side-item" id="where-play">

                    <span class="menu-link menu-center">
                        <span class="menu-icon me-0">
                                <i class="fad fa-play"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.play">Play</span>
                    </span>
    
                    
                    <div class="menu-sub menu-sub-dropdown px-2 py-4 w-225px w-lg-250px mh-75 overflow-auto" style="">
                    
                        <div class="menu-item">
                    
                            <div class="menu-content text-center text-gray-800">
                                <span class="fs-6 fw-normal py-1" data-i18n="aside.tplayb"></span>
                            </div>
                    
                        </div>
                                                
                        <div class="menu-item">
                            <a href="play/ranked" id="sub-ranked" data-navigo class="side-sub w-100 btn btn-flex btn-color-muted btn-active-light btn-active-color-white disabled"  data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-bs-original-title="Real Competition">
                                <i class="fad fa-swords fs-4 pe-0 me-3"></i>
                                <span class="d-flex flex-column align-items-start">
                                    <span class="fs-7 fw-bold text-uppercase">Ranked Matchmaking</span>
                                </span>
                            </a>                            
                        </div>

                        <div class="menu-item">
                            <a href="play/custom" id="sub-custom" data-navigo class="side-sub w-100 btn btn-flex btn-color-muted btn-active-light btn-active-color-white disabled"  data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-bs-original-title="Real Competition">
                                <i class="fad fa-users-cog fs-4 pe-0 me-3"></i>
                                <span class="d-flex flex-column align-items-start">
                                    <span class="fs-7 fw-bold text-uppercase">Custom Matches</span>                                    
                                </span>
                            </a>
                        </div>

                        <div class="menu-item">
                            <a href="play/pug"  id="sub-pug" data-navigo class="side-sub w-100 btn btn-flex btn-color-gray-800 btn-active-light btn-active-color-white"  data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-bs-original-title="PUG, Mix, Old gather system">
                                <i class="fad fa-sword fs-4 pe-0 me-3"></i>
                                <span class="d-flex flex-column align-items-start">
                                    <span class="fs-7 fw-bold text-uppercase">PUG (Pick Up Game)</span>                                    
                                </span>
                            </a>
                        </div>

                        <div class="menu-item">
                            <a href="play/training" id="sub-training" data-navigo class="side-sub w-100 btn btn-flex btn-color-gray-800 btn-active-light btn-active-color-white"  data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-bs-original-title="Aim, Deathmatch, Wallbang ...">
                                <i class="fad fa-dumbbell fs-4 pe-0 me-3"></i>
                                <span class="d-flex flex-column align-items-start">
                                    <span class="fs-7 fw-bold text-uppercase">Training Servers</span>                                    
                                </span>
                            </a>
                        </div>
                        
                    </div>
                        
                
                </div>-->

                <div class="menu-item py-1 side-item" id="where-home">
                    <a href="home" data-navigo class="menu-link menu-center" title="" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.thome;[data-bs-original-title]aside.thome">
                        <span class="menu-icon me-0">                            
                            <i class="fad fa-home-lg"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.home">Home</span>
                    </a>
                </div>

                <div class="menu-item py-1 side-item" id="where-play">
                    <a href="play" data-navigo class="menu-link menu-center" title="Let's Play" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tplay;[data-bs-original-title]aside.tplay">
                        <span class="menu-icon me-0">                            
                            <i class="fad fa-play"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.play">Play</span>
                    </a>
                </div>

                <div class="menu-item py-1 side-item" id="where-leaderboard">
                    <a href="leaderboard" data-navigo class="menu-link menu-center" title="Are you ready for reality?" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tleaderboards;[data-bs-original-title]aside.tleaderboards">
                        <span class="menu-icon me-0">
                            <!--<i class="bi bi-file-bar-graph fs-2"></i>-->
                            <i class="fad fa-analytics"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.leaderboards">Leaders</span>
                    </a>
                </div>
                

                <div class="menu-item py-1 side-item" id="where-matches">
                    <a href="matches" data-navigo class="menu-link menu-center" title="All played matches" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tmatches;[data-bs-original-title]aside.tmatches">
                        <span class="menu-icon me-0">
                            <!--<i class="bi bi-controller fs-2"></i>-->
                            <i class="fad fa-gamepad"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.matches">Matches</span>
                    </a>
                </div>

                <div class="menu-item py-1 side-item" id="where-players">
                    <a href="players" data-navigo class="menu-link menu-center" title="Player's list" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tplayers;[data-bs-original-title]aside.tplayers">
                        <span class="menu-icon me-0">
                            <!--<i class="bi bi-person-lines-fill fs-2"></i>-->
                            <i class="fad fa-users"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.players">Players</span>
                    </a>
                </div>

                                                
                <div class="menu-item py-1 side-item" id="where-ac">
                    <a href="services/anticheat" data-navigo class="menu-link menu-center" title="Akros Anticheat" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tac;[data-bs-original-title]aside.tac">
                        <span class="menu-icon me-0">
                            <!--<i class="bi bi-shield fs-2"></i>-->
                            <i class="fad fa-shield"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.ac">Anticheat</span>
                    </a>
                </div>

                <!--<div class="menu-item py-1 side-item" id="where-social">
                    <a href="social" data-navigo class="menu-link menu-center" title="Share whatever you want" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tsocial;[data-bs-original-title]aside.tsocial">
                        <span class="menu-icon me-0">
                            <i class="bi bi-journal-richtext fs-2"></i>                        
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.social">Social</span>
                    </a>
                </div>-->

                
                <div class="menu-item py-1 side-item" id="where-banlist">
                    <a href="bans" data-navigo class="menu-link menu-center" title="Banlist" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tbans;[data-bs-original-title]aside.tbans">
                        <span class="menu-icon me-0">                            
                            <i class="fad fa-user-times"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.bans">Bans</span>
                    </a>
                </div>
                
                <div class="menu-item py-1 side-item" id="where-support">
                    <a href="services/faq" data-navigo class="menu-link menu-center" title="Support center and help" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right" data-i18n="[title]aside.tfaq;[data-bs-original-title]aside.tfaq">
                        <span class="menu-icon me-0">
                            
                            <i class="fad fa-headset"></i>
                        </span>
                        <span class="menu-title text-uppercase fs-8" data-i18n="aside.faq">Support</span>
                    </a>
                </div>
                
                
            </div>
            <!--end::Menu-->
        </div>
        <!--end::Aside Menu-->
    </div>
    <!--end::Aside menu-->
    <!--begin::Footer-->
    <div class="aside-footer flex-column-auto" id="kt_aside_footer">
        <!--begin::Menu-->
        <div class="d-flex justify-content-center">
            <button type="button" class="btn btm-sm btn-icon btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-overflow="true" data-kt-menu-placement="top-start" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-dismiss="click" title="Language">
                <!--begin::Svg Icon | path: icons/duotune/general/gen008.svg-->
                <span class="menu-icon">
                    <img class="w-25px flag-lang" src="assets/media/flags/us.gif"/>
                </span>
                <!--end::Svg Icon-->
            </button>
            <!--begin::Menu 2-->
            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px" data-kt-menu="true">
                <!--begin::Menu item-->
                <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-dark fw-bolder px-3 py-4">Languages</div>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu separator-->
                <div class="separator mb-3 opacity-75"></div>
                <!--end::Menu separator-->
                <!--begin::Menu item-->
                <div class="menu-item px-3 mt-2">
                    <span class="menu-link btn-lang px-3" data-lang="en-US" data-flag="us"><img class="w-25px me-2" src="assets/media/flags/us.gif"/> <span>English</span></span>
                </div>
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <div class="menu-item px-3">
                    <span class="menu-link btn-lang px-3" data-lang="es-ES" data-flag="es"><img class="w-25px me-2" src="assets/media/flags/es.gif"/> <span>Español</span></span>
                </div>
                <!--end::Menu item-->
                <div class="menu-item px-3 mb-2">
                    <span class="menu-link btn-lang px-3" data-lang="pt-BR" data-flag="br"><img class="w-25px me-2" src="assets/media/flags/br.gif"/> <span>Portuguêse</span></span>
                </div>
                <!--end::Menu item-->
                <!--end::Menu item-->
                <div class="menu-item px-3 mb-2">
                    <span class="menu-link btn-lang px-3" data-lang="zh-CN" data-flag="cn"><img class="w-25px me-2" src="assets/media/flags/cn.gif"/> <span>中文</span></span>
                </div>
                <!--end::Menu item-->
            </div>
            <!--end::Menu 2-->
        </div>
        <!--end::Menu-->
    </div>
    <!--end::Footer-->
`;

export default view;